import {
  Empty_NoSqlDoc,
  FBDTKeygenGeneric,
  MakeFBDocType,
  NoSqlDoc,
} from '@rabbit/firebase/doctype';

export interface DTLabel extends NoSqlDoc {
  /** Label identifier */
  key: string;
  /** Label value */
  label: string;
  /** Tenant link who owns the label */
  tenantLink: string;
  /** Partner link that created the label */
  createdBy: string;
}

export const FBD_Labels = MakeFBDocType<DTLabel>({
  name: 'Labels',
  collection: 'labels',
  empty: () => ({
    ...Empty_NoSqlDoc(),
    key: '',
    label: '',
    tenantLink: '',
    createdBy: '',
  }),
  keygen: FBDTKeygenGeneric,
});
